import { createServiceAction } from '../util/actionHelper.js';
import { apiConfig } from '../configs/apiConfig.js';
import { postRequest, displayMessage } from '../util/index.js';
import { getHTTPStatusValidationMessage, getServerValidationMessage } from '../services/serverValidations.js';

import { put, takeEvery, call } from 'redux-saga/effects';

export function* listener(serviceType, action) {
  try {
    const data = { ...action.data, action: 'upload' };
    const infoPopDuration = 1000;
    
    yield call(displayMessage, 'info', 'Saving training material record...', infoPopDuration);
    yield put(createServiceAction(serviceType, 'loading')());
    const res = yield call(postRequest, apiConfig.trainingMaterial.endPointUrl, data);
    
    const statusErrorMessage = yield call(getHTTPStatusValidationMessage, res, infoPopDuration);
    if (!statusErrorMessage) {
      const response = yield res.json();
      const serverErrorMessage = yield call(getServerValidationMessage, response, infoPopDuration);
      if (!serverErrorMessage && response.errorCode === 0) {
        yield put(createServiceAction(serviceType, 'success')(response.data));
        const message = response.message || 'Training material uploaded successfully';
        yield call(displayMessage, 'success', message, 5000);
      }
    }
  } catch (e) {
    yield put(createServiceAction(serviceType, 'error')(e));
    yield call(displayMessage, 'error', 'Failed to upload training material', 5000);
  }
}

function* uploadTrainingMaterial() {
  const serviceType = 'uploadTrainingMaterial';
  yield takeEvery(createServiceAction(serviceType, 'requested').type, listener, serviceType);
}

export default uploadTrainingMaterial;
